import type { SerializedBlockNode } from '@payloadcms/richtext-lexical';
import type { FormBlock } from '@/payload-types';

import { FormBlockComponent } from '@/payload/blocks/form/components';

export const FormBlockJSXConverter = {
  formBlock: ({ node }: { node: SerializedBlockNode<FormBlock> }) => {
    if (node.fields.blockType === 'formBlock') {
      return <FormBlockComponent {...node.fields} />;
    }
    return null;
  },
};
